export default __webpack_public_path__ + "staticFile/media/arrow.147f0971.svg";